exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.page-title{\r\n      text-align: right;\r\n    font-weight: bold;\r\n    font-size: 20px;\r\n    margin-top: 0;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-6ab95910","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./scripts/src/pages/meet-the-team/meet-the-team.vue
// module id = 602
// module chunks = 0